import axios from "axios";
import { URI, getToken } from "./Conexion";

export async function loginApi(urlEndPoint,Data) {
    try {
        const endpoint = URI + urlEndPoint;
        const data = Data;
        const res = await axios.post(endpoint,data);
        return {status:1, data:res.data};
    } catch (error) {
        return {status:0, message: error.message}
    }
}

function getOptions() {
    const options = {
        headers: {
            'Authorization': `Bearer ${getToken()}`
        },
    }
    return options;
}

export async function getApi (urlEndPoint){
    try {
        const endpoint = URI + urlEndPoint;
        const options = getOptions();
        const res = await axios.get(endpoint, options);
        if(res.status === 210){
            return {status:res.status};
        }else{
            return {status:1, data:res.data};
        }
    } catch (error) {
        return {status:0, message: error.message}
    }
}

export async function postApi(urlEndPoint, nData) {
    try {
        const endpoint = URI + urlEndPoint;
        const data = nData;
        const options = getOptions();
        const res = await axios.post(endpoint, data, options);
        if(res.status === 210){
            return {status:res.status};
        }else{
            return {status:1, data:res.data};
        }
    } catch (error) {
        return {status:0, message: error.message}
    }
}

export async function putApi(urlEndPoint, nData) {
    try {
        const endpoint = URI + urlEndPoint;
        const data = nData;
        const options = getOptions();
        const res = await axios.put(endpoint, data, options);
        if(res.status === 210){
            return {status:res.status};
        }else{
            return {status:1, data:res.data};
        }
    } catch (error) {
        return {status:0, message: error.message}
    }
}

export async function deleteApi(urlEndPoint) {
    try {
        const endpoint = URI + urlEndPoint;
        const options = getOptions();
        const res = await axios.delete(endpoint, options);
        if(res.status === 210){
            return {status:res.status};
        }else{
            return {status:1, data:res.data};
        }
    } catch (error) {
        return {status:0, message: error.message}
    }
}

export async function postApiImg(urlEndPoint, nData) {
    try {
        const endpoint = URI + urlEndPoint;
        const data = nData;
        function getConfig() {
            const options = {
                headers: {
                    'Authorization': `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data",
                },
            }
            return options;
        }
        const options = getConfig();
        const res = await axios.post(endpoint, data, options);
        if(res.status === 210){
            return {status:res.status};
        }else{
            return {status:1, data:res.data};
        }
    } catch (error) {
        return {status:0, message: error.message}
    }
}

export async function putApiImg(urlEndPoint, nData) {
    try {
        const endpoint = URI + urlEndPoint;
        const data = nData;
        function getConfig() {
            const options = {
                headers: {
                    'Authorization': `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data",
                },
            }
            return options;
        }
        const options = getConfig();
        const res = await axios.put(endpoint, data, options);
        if(res.status === 210){
            return {status:res.status};
        }else{
            return {status:1, data:res.data};
        }
    } catch (error) {
        return {status:0, message: error.message}
    }
}